import Hosts from '../../../Hosts';

const object_type = 'web/content'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`

const base_endpoint = '/intranet_corporate'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    // list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        name: '',
        type: 'corporate',
        layout: 'normal',
        category: '',
        date: {
            creation: '',
            published: '',
            avaiable: '',
            modified: []
        },
        language: [],
        media: {
            id: '',
            link: '',
        },  
        seo: {
            title: '',
            description: '',
            keywords: '',
            language: []
        }, 
        tags: [],
        parent: '0',
        order: '1',
        slug: '', 
        status: 'draft'
    },
    content: [{
        title: [],
        subtitle: [],
        abstract: [],
        text: [],
        media: {
            image: [],
            doc: []
        },
        contacts: {
            tlf: '',
            tlm: '',
            fax: '',
            email: '',
            morada: '',
            website: '',
            website_type: 'https://',
        },
        language: []
    }]
}

export {
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
